import styled from 'styled-components';

export const Switch = styled.div`
  display: flex;
  position: relative;
  height: 26px;
  background-color: #e4e4e4;
  border-radius: 3px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);
  margin-right: 17px;
  min-width: 240px;

  span {
    width: 33%;
  }
`;

export const SwitchRadio = styled.input`
  display: none;
`;

export const SwitchSelection = styled.span`
  display: block;
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  width: 33%;
  height: 26px;
  background: #1890ff;
  border-radius: 3px;
  transition: left 0.25s ease-out;
`;

export const SwitchLabel = styled.label`
  position: relative;
  z-index: 2;
  float: left;
  line-height: 26px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  cursor: pointer;
  width: 100%;

  ${SwitchRadio}:checked + &{
    transition: 0.15s ease-out;
    color: #fff;
  }

`;
